
define('app/dashboard/leagues/leaguesMain',[
	'domReady',
	'app/dashboard/leagues/leaguesApp',
	'app/common/setup'
], function(domReady, LeaguesApp, Setup){
	domReady(function () {
		Setup.initialize();
		LeaguesApp.initialize();
    });
});